export default __webpack_public_path__ + "Digitale Schadenmeldung für Reifen- und Komplettradgarantien von Mercedes-Benz - Impressum_Stand 11-2025.pdf";